import { Color, IconName } from '@billy/design-system'

import { CegidIntegrationStatus } from '../enums/cegidIntegrationStatus'

interface CegidIntegrationStatusIconAndColor {
  icon: IconName
  color: Color
}

export const cegidIntegrationStatusToIcon: Record<CegidIntegrationStatus, CegidIntegrationStatusIconAndColor> = {
  [CegidIntegrationStatus.Failed]: {
    icon: 'circleAlert',
    color: Color.Red700,
  },
  [CegidIntegrationStatus.Pending]: {
    icon: 'circleDashed',
    color: Color.Lavender400,
  },
  [CegidIntegrationStatus.Processing]: {
    icon: 'circleDashed',
    color: Color.Lavender400,
  },
  [CegidIntegrationStatus.Posted]: {
    icon: 'circleCheck',
    color: Color.Green400,
  },
}
